import { gql } from '@apollo/client'

export const GET_CHANNEL = gql`
  query GetChannel($id: ID!) {
    channel(id: $id) {
      id
      name
      description
      image
      updatedAt
      followersCount
      viewerIsOwner
      viewerIsFollowing
    }
  }
`
